/*jshint esversion: 11 */
import React from 'react';
import { Progress } from 'reactstrap';

const ExportProgressOverlay = ({ visible, progress, message }) => {
  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
        backgroundColor: 'rgba(0, 0, 0, 0.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: '8px',
          padding: '24px 32px',
          minWidth: '320px',
          maxWidth: '90vw',
          boxShadow: '0 4px 24px rgba(0,0,0,0.15)'
        }}
      >
        <p className="mb-3 text-center font-weight-medium">{message}</p>
        <Progress value={progress} style={{ height: '8px' }} />
        <p className="mb-0 mt-2 text-center text-muted small">{progress}%</p>
      </div>
    </div>
  );
};

export default ExportProgressOverlay;
